<div class="page-print-label-component" fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="start center">
    <app-label class="card-element"></app-label>
    <app-printer class="card-element"></app-printer>
    <!-- <app-label-preview class="card-element"></app-label-preview> -->
</div>

